import React from 'react';
import { Grid, TextField } from '@mui/material';

export const FormField = ({ name, values, errors, setFieldValue, ...other }) => (
  <TextField
    label="Name"
    variant="outlined"
    size="small"
    value={values[name]}
    onChange={e => setFieldValue(name, e.target.value)}
    error={errors[name]}
    helperText={errors[name]}
    {...other}
  />
);

export const FullWidthField = props => (
  <Grid item xs={12}>
    <FormField {...props} fullWidth/>
  </Grid>
);
